import React, { FunctionComponent } from 'react'
import Section from './shared/section/sectionWrapper';
import { StaticImage } from 'gatsby-plugin-image'
import Text from './shared/text';
const EpodLife:FunctionComponent = ()=> {
    return (
        <Section className="bg-bytestrone-blue relative  px-6 ">
            <div className="flex flex-col w-full h-full  p-5 md:py-5 py-20">
                <Text className="text-center text-white lg:text-right whitespace-nowrap mb-5" textType="headerL">Living the e-pod Life</Text>
                <div className="w-full flex flex-wrap items-center ">
                    <div className="lg:w-1/2">
                        <div className="w-11/12"><StaticImage alt="epod-life" className="object-fill" src="../images/living-the-e-pod-life.png" placeholder="blurred" quality={75}/></div>
                    </div>
                    <div className="lg:w-1/2">
                        
                            <Text textType="contentL" className="text-white text-left mt-3 md:pl-24">
                                <strong>Stand Up.</strong> Get focus on the day. Team owns it and drives it everyday at same place and same time
                            </Text>
                            <Text textType="contentL" className="text-white text-left mt-3 md:pl-24">
                                <strong>Pair UP.</strong> Pair produces code. Typist think tactically, partner think strategically. Switch roles periodically.
                            </Text>
                            <Text textType="contentL" className="text-white text-left mt-3 md:pl-24">
                                <strong>Test.</strong> Write unit test code, test everything that could possibly break.
                            </Text>
                            <Text textType="contentL" className="text-white text-left mt-3 md:pl-24">
                                <strong>Code.</strong> Verify tests for failure before coding. Follow the coding standards, dev complete criteria.
                            </Text>
                            <Text textType="contentL" className="text-white text-left mt-3 md:pl-24">
                                <strong>Refactor.</strong> Fix if code smells, remove duplicate logic and heavy methods or classes.
                            </Text>
                            <Text textType="contentL" className="text-white text-left mt-3 md:pl-24">
                                <strong>Q&A.</strong> Product owner provides immediate decisions/ answers. Build acceptance test to capture it.
                            </Text>
                            <Text textType="contentL" className="text-white text-left mt-3 md:pl-24">
                                <strong>Integrate or Toss.</strong> Integrate, test and fix. Make it 100% unbreakable. If unable to integrate, then toss it and start fresh.
                            </Text>
                            <Text textType="contentL" className="text-white text-left mt-3 md:pl-24">
                                <strong>Go Home.</strong> Nothing is hanging with you today. Make sure either its integrated or tossed.
                            </Text>
                       
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default EpodLife;